<template>
  <div class="search">
    <el-form ref="form" :model="searchForm" :inline="true" label-width="120px">
      <el-form-item label="咨询工单号">
        <el-input
          v-model="searchForm.consultNum"
          placeholder="请输入咨询工单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户名称">
        <el-input
          v-model="searchForm.customerName"
          placeholder="请输入客户名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户账号">
        <el-input
          v-model="searchForm.customerAccountNum"
          placeholder="请输入客户账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="国家">
        <el-select
          filterable
          clearable
          v-model="searchForm.countryId"
          placeholder="请选择国家"
        >
          <el-option
            v-for="item in nationList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="疑似/祸首件名称">
        <el-input
          v-model="searchForm.suspectedCulpritName"
          placeholder="请输入疑似/祸首件名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="疑似/祸首件代码">
        <el-input
          v-model="searchForm.suspectedCulpritCode"
          placeholder="请输入疑似/祸首件代码"
        ></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-input v-model="searchForm.carBrand" placeholder="请输入品牌"></el-input>
      </el-form-item>
      <el-form-item label="车型">
        <el-input v-model="searchForm.carModel" placeholder="请输入车型"></el-input>
      </el-form-item>

      <el-form-item label="是否回复">
        <el-select
          filterable
          clearable
          v-model="searchForm.replyOrNot"
          placeholder="请选择"
        >
          <el-option label="是" value="1"> </el-option>
          <el-option label="否" value="0"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="咨询日期">
        <el-date-picker
          v-model="searchForm.date"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:300px"
        >
        </el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="是否回复：">
        <el-select
          filterable
          v-model="searchForm.replyOrNot"
          placeholder="请选择"
          clearable
        >
          <el-option label="是" value="是"> </el-option>
          <el-option label="否" value="否"> </el-option>
        </el-select>
      </el-form-item> -->
      <el-button
        type="primary"
        @click="handleSearch()"
        >查询</el-button
      >
      <el-button type="primary" plain @click="handleResetQuery"
        >重置</el-button
      >
    </el-form>

    <!-- <el-button size="small" type="primary" >导出结果</el-button> -->
  </div>
</template>
<script>
import { getSession } from "@/util/localStor";
export default {
  props: {
    recordsSearchObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      searchForm: {
        consultNum: "",
        customerName: "",
        customerAccountNum: "",
        countryId: "",
        suspectedCulpritName: "",
        suspectedCulpritCode: "",
        carBrand: "",
        carModel: "",
        replyOrNot: "",
        date: ""
      },
      state: "",
      timeout: null,
      nationList: []
    };
  },
  mounted() {
    this.searchForm = { ...this.searchForm, ...this.recordsSearchObj };
    this.nationList = Object.values(getSession("nationList"));
  },
  methods: {
    handleSearch(type) {
      this.$emit("handleSearch", this.searchForm, type);
    },

    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    // 重置查询条件
    handleResetQuery() {
      this.searchForm = Object.assign({}, this.$options.data()?.searchForm);
      this.handleSearch("reset");
    }
  }
};
</script>
